<template lang="pug">
component.button.gap-2.align-items-center(
  :is='isType'
  :text='props.text'
  v-bind="{ isUnderLine: 'none', linkColor: props.linkColor}"
  :fontWeight="props.fontWeight"
  :aria-disabled="ariaDisabled"
  :aria-label="props.ariaLabel || null"
  :tabindex="tabIndexValue"
  :link="props.link"
  :class="allClasses"
  @click="preventDisabledClick"
  @keydown="preventDisabledKeydown"
)
  template(v-if="$slots.prevLabel" #prevLabel)
    slot(name="prevLabel" :text="props.text")
  template(v-if="$slots.icon" #icon)
    slot(name="icon")
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { type InteractiveArchetypeProps } from './InteractiveArchetype.types';
import { interactiveArchetypeDefaults } from './InteractiveArchetype.defaults';
import useInteractivesPseudoDisabled from '../../../composables/useInteractivesPseudoDisabled';
import usePrimitiveResolver from '../../../composables/usePrimitiveResolver';
import useSkin from '../../../composables/useSkin';
import useSkinInteractive from '../../../composables/useSkinInteractive';

const props = withDefaults(
  defineProps<InteractiveArchetypeProps>(),
  interactiveArchetypeDefaults as any,
) as unknown as InteractiveArchetypeProps;

const { allClasses: baseClasses } = useSkin(props as any);

const {
  allClasses: disabledClasses,
  ariaDisabled,
  tabIndexValue,
  preventDisabledClick,
  preventDisabledKeydown,
} = useInteractivesPseudoDisabled(props as any);

const { allClasses: interactiveClasses } = useSkinInteractive(props as any);

const allClasses = computed(() => {
  return [baseClasses.value, disabledClasses.value, interactiveClasses.value]
    .filter(Boolean)
    .join(' ');
});

const { isType } = usePrimitiveResolver(props as any);
</script>

<style lang="scss">
.button {
  $block: &;

  &#{&} {
    position: relative;
    display: flex;
    height: fit-content;
    width: unset;
  }

  &.disabled,
  &:disabled {
    cursor: not-allowed;
    pointer-events: unset;
  }

  &#{&} {
    &--disabled {
      cursor: not-allowed;
      pointer-events: unset;
      opacity: 0.5;
    }
  }
}

button,
input {
  border: unset;
  padding: unset;
  background-color: unset;
  height: auto;
}
</style>
